import { MiniMapManager } from '.';

export default class PlanImageManager extends MiniMapManager {
    _MINIMAPWIDTH = 640;

    _MINIMAPHEIGHT = 480;

    // get MINIMAPWIDTH():number {return this._MINIMAPWIDTH;}
    // get MINIMAPHEIGHT():number {return this._MINIMAPHEIGHT;}
    minimapType = 1;
}
